module.exports = __webpack_public_path__ + "static/media/1POLICY2.b15db0c4.jpg";